"use client";

import type { TrackedPhoneLinkProps } from "~www/types/tracked-phone-link-props";

import { trackPhoneClick } from "@homeinstead/analytics";
import Phone from "@homeinstead/icons/Phone";
import { default as PhoneLink } from "@homeinstead/ui/components/PhoneLink";

const TrackedPhoneLink = ({
  className,
  phoneNumber,
  placement,
  variant,
  children,
  withIcon,
  ...props
}: TrackedPhoneLinkProps) => {
  const iconColorClass =
    variant === "outline-dark" ? "fill-white" : "fill-new-beginnings-base";

  return (
    <PhoneLink
      className={className}
      onClick={() => trackPhoneClick({ placement })}
      phoneNumber={phoneNumber}
      variant={variant}
      {...props}
    >
      <>
        {!withIcon ? null : (
          <Phone className={iconColorClass} data-testid="phone-icon" />
        )}
        {children ?? phoneNumber}
      </>
    </PhoneLink>
  );
};

export { TrackedPhoneLink };
